interface RunResultsItemCountProps {
  hasExplicitNoSelection?: boolean
  hasLowSampleWarning?: boolean
  hasNoUsableMetricData?: boolean
  hasOutlierError?: boolean
  isOutlierAnalysisPending?: boolean
  itemCount: number
  outlierCount?: number
  outliersEnabled?: boolean
}

export function RunResultsItemCount({
  hasExplicitNoSelection = false,
  hasLowSampleWarning = false,
  hasNoUsableMetricData = false,
  hasOutlierError = false,
  isOutlierAnalysisPending = false,
  itemCount,
  outlierCount = 0,
  outliersEnabled = false,
}: RunResultsItemCountProps) {
  const showWarnings =
    outliersEnabled && !hasOutlierError && !isOutlierAnalysisPending

  return (
    <span className="text-sm text-coval-text-muted whitespace-nowrap px-2">
      {itemCount} {itemCount === 1 ? "item" : "items"}
      {outliersEnabled ? (
        <>
          {" · "}
          <span aria-live="polite">
            {hasOutlierError
              ? "Outliers unavailable"
              : isOutlierAnalysisPending
                ? "Fetching outliers…"
                : `${outlierCount} ${outlierCount === 1 ? "outlier" : "outliers"}`}
            {showWarnings && hasExplicitNoSelection ? (
              <>
                {" · "}
                <span className="text-coval-warning-text">
                  No outlier metrics selected
                </span>
              </>
            ) : null}
            {showWarnings && hasNoUsableMetricData ? (
              <>
                {" · "}
                <span className="text-coval-warning-text">
                  Not enough metric data
                </span>
              </>
            ) : null}
            {showWarnings && hasLowSampleWarning ? (
              <>
                {" · "}
                <span className="text-coval-warning-text">
                  Low sample size (&lt;12 results per metric)
                </span>
              </>
            ) : null}
          </span>
        </>
      ) : null}
    </span>
  )
}
